
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.683 8.16a3.869 3.869 0 01-1.255 6.309 3.869 3.869 0 01-5.35-3.574 3.869 3.869 0 016.605-2.736","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M2 4.336v13.118a2.283 2.283 0 002.284 2.283h15.328a2.283 2.283 0 002.283-2.284V4.336a2.283 2.283 0 00-2.284-2.283H4.283A2.284 2.284 0 002 4.336v0zm9.229 7.332l1.437-1.547M4.21 21.947v-2.21m15.474 2.21v-2.21m2.21-14.369H23m-1.105 9.948H23","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    